/* eslint-disable */
import $ from "jquery";
import paroller from "paroller.js";
import Vue from "vue";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

//import Articles from "./components/Articles.vue";
//import Posts from "./components/Posts.vue";
//import Projects from "./components/Projects.vue";
import lozad from "lozad";

// usage: log('inside coolFunc',this,arguments);
// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function() {
  log.history = log.history || []; // store logs to an array for reference
  log.history.push(arguments);
  if (this.console) {
    window.console.log(Array.prototype.slice.call(arguments));
  }
};

/*
new Vue({
  el: "#app",
  components: { Articles, Posts, Projects }
});
*/

window.jQuery = window.$ = require("jquery");

//const observer = lozad();
//observer.observe();

let jQuery = $;

// Add amination for header text list
// $("#slideshow > div:gt(0)").hide();
// setInterval(function() {
//   $("#slideshow > div:first")
//     .fadeOut(1000)
//     .next()
//     .fadeIn(1000)
//     .end()
//     .appendTo("#slideshow");
// }, 3000);

//Add Sub-link is-active
$(".features-link-list a").each(function(e) {
  if (this.href == document.location.toString()) {
    $(this).addClass("active");
  }
});

// Fade up elements
var $window = $(window);
var $doc = $(document);
var $hideMe = $('.highlight-wrapper');

$doc.ready(function () {

  $window.scroll(function () {
    var bottom_of_window = $window.scrollTop() + $window.height();

    $hideMe.each(function (i) {
      var $elm = $hideMe.eq(i);
      var top_of_object = $elm.offset().top + 100;

      if (bottom_of_window > top_of_object) {
        if (!$elm.hasClass('in-viewport')) {
          $elm.addClass('in-viewport');
        }
      }
    });
  });

  $(window).scroll();

});

//Choice the style of css for number of columns to show.
if ($(".features-column div").length == 2) {
  $(".features-column").addClass("is-grid-two-columns");
}
if ($(".features-column div").length == 3) {
  $(".features-column").addClass("is-grid-three-columns");
}
if ($(".features-column div").length == 4) {
  $(".features-column").addClass("is-grid-four-columns");
}

//Parallax effect for front page images
$(".right-image").paroller({ factor: 0.5, factorXs: 0.2, factorSm: 0.3, type: 'foreground', direction: 'vertical' });
$(".left-image").paroller({ factor: 0.3, factorXs: 0.2, factorSm: 0.3, type: 'foreground', direction: 'vertical' });

iziToast.settings({
  position: 'topCenter',
  timeout: 6500,
  progressBar: true,
  closeOnClick: true,
  transitionIn: 'fadeInDown',
  transitionOut: 'fadeOutUp',
  fontFamily: 'skolar-sans-latin, sans-serif',
  maxWidth: 480,
});

document.addEventListener('wpcf7mailsent', function () {
  iziToast.success({
    class: 'aly-toast',
    title: 'Kiitos!',
    message: 'Tietosi on lähetetty onnistuneesti.',
    timeout: 8000,
  });
}, false);

document.addEventListener('wpcf7invalid', function () {
  iziToast.error({
    class: 'aly-toast',
    title: 'Tarkista tiedot',
    message: 'Lomakkeessa on virheitä. Tarkista merkityt kentät.',
    timeout: 7000,
  });
}, false);

document.addEventListener('wpcf7mailfailed', function () {
  iziToast.error({
    class: 'aly-toast',
    title: 'Lähetys epäonnistui',
    message: 'Viestin lähetys epäonnistui. Yritä uudelleen.',
    timeout: 7000,
  });
}, false);

document.addEventListener('wpcf7spam', function () {
  iziToast.warning({
    class: 'aly-toast',
    title: 'Hylätty',
    message: 'Lomakkeen lähetys hylättiin.',
    timeout: 7000,
  });
}, false);


// WEBPACK FOOTER //
// ./resources/assets/js/main.js